import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-gray-900 border-t border-white/10 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="https://4kdreamers.com/logo.webp" alt="Logo" className="h-12 w-auto object-contain" width={250} height={100} />

            </div>
            <p className="text-muted-foreground text-sm">Streaming TV Premium International - Films, Séries &amp; Chaînes TV en 4K</p>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.services')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>{t('footer.s1')}</li><li>{t('footer.s2')}</li><li>{t('footer.s3')}</li><li>{t('footer.s4')}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.contact')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>📞 +12057092376</li><li>📧 support@4kdream.com</li><li>🕒 Support 7j/7 10h-23h</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.coverage')}</h3>
            <ul className="space-y-2 text-muted-foreground text-sm">
              <li>{t('footer.cov1')}</li><li>{t('footer.cov2')}</li><li>{t('footer.cov3')}</li><li>{t('footer.cov4')}</li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading text-lg mb-4 text-white">{t('footer.legal')}</h3>
            <ul className="space-y-2 text-sm">
              {(['l1','l2','l3','l4','l5'] as const).map(k => (
                <li key={k}><a href="#" className="text-muted-foreground hover:text-primary transition-colors">{t(`footer.${k}`)}</a></li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-muted-foreground text-sm">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
}
